document.addEventListener('DOMContentLoaded', function () {
    var stockDataEl = document.getElementById('variation-stock-data');
    if (!stockDataEl || !stockDataEl.textContent) return;

    var stockData = JSON.parse(stockDataEl.textContent);
    var stockLevelsDiv = document.querySelector('.stock-levels--delivery');
    var madeToOrderDiv = document.querySelector('.stock-levels__made--var');

    var hideStockLevels = function () {
        stockLevelsDiv.style.display = 'none';
        stockLevelsDiv.removeAttribute('var-stock');
    };

    // When a valid variation is selected
    jQuery('form.variations_form').on('found_variation', function (event, variation) {
        var variationId = variation.variation_id;

        if (stockData[variationId]) {
            var stock = stockData[variationId].stock;
            var allowBackorders = stockData[variationId].backorders_allowed;

            // console.log(allowBackorders);
            // console.log(stock);

            stockLevelsDiv.setAttribute('var-stock', stock);

            if (stock <= 0 && !allowBackorders) {
                stockLevelsDiv.style.display = 'none';
            } else {
                stockLevelsDiv.style.display = 'flex';
            }

            // showing the made to order label if its not in stock but on backorder
            if(stock <= 0 && allowBackorders) {
                madeToOrderDiv.style.display = 'flex';
            } else {
                madeToOrderDiv.style.display = 'none';
            }
        }
    });

    // When the variation is reset (e.g., "Choose an option" is selected)
    jQuery('form.variations_form').on('reset_data woocommerce_variation_has_changed', function () {
        var $form = jQuery(this);

        // Check if all required attributes are selected
        var allSelected = true;
        $form.find('.variations select').each(function () {
            if (!this.value || this.value === '') {
                allSelected = false;
            }
        });

        if (!allSelected) {
            hideStockLevels();
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    var stockDataEl = document.getElementById('variation-stock-data');
    if (!stockDataEl || !stockDataEl.textContent) return;

    var stockData = JSON.parse(stockDataEl.textContent);
    var stockLevelsColDiv = document.querySelector('.stock-levels--collection');

    var hideStockLevelsCol = function () {
        stockLevelsColDiv.style.display = 'none';
        stockLevelsColDiv.removeAttribute('var-col-stock');
    };

    // When a valid variation is selected
    jQuery('form.variations_form').on('found_variation', function (event, variation) {
        var variationId = variation.variation_id;

        if (stockData[variationId]) {
            var stock = stockData[variationId].var_col_stock;

            stockLevelsColDiv.setAttribute('var-col-stock', stock);

            if (stock <= 0) {
                stockLevelsColDiv.style.display = 'none';
            } else {
                stockLevelsColDiv.style.display = 'block';
            }
        }
    });

    // When the variation is reset or not fully selected
    jQuery('form.variations_form').on('reset_data woocommerce_variation_has_changed', function () {
        var $form = jQuery(this);

        var allSelected = true;
        $form.find('.variations select').each(function () {
            if (!this.value || this.value === '') {
                allSelected = false;
            }
        });

        if (!allSelected) {
            hideStockLevelsCol();
        }
    });
});
